import React from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import Join from './components/Join';
import Dashboard from './components/Dashboard';
import { PrivateRoute } from './routes/PrivateRoute';
import './App.css';

const routes = [
  { name: "login", path: "/", exact: true, main: () => <Join /> },
  { name: "user", path: "/dashboard-:user", exact: false, main: () => <PrivateRoute Component={Dashboard} /> },
];

function App() {

  return (
    <div className="App">
      <Router>
        <Switch>
          {routes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              component={route.main}
            />
          ))}
        </Switch>
      </Router>
    </div>
  );
}

export default App;
